module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-4-f331f36ef6d419a6c28922900a1aaf08.webp";